<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    
    // Resumen de cobros
    v-container(v-if="resumenPorMetodo.length > 0" style="margin-top: 8px; padding: 0 12px;")
      v-layout(row wrap)
        // Cards para cada método de pago
        v-flex(xs6 sm4 md3 lg2 v-for="(metodo, index) in resumenPorMetodo" :key="index" style="padding: 3px;")
          v-card(elevation="2" style="height: 100%;")
            v-card-text(style="padding: 6px;")
              div(style="text-align: center;")
                v-icon(small color="primary" style="margin-bottom: 2px;") mdi-cash-multiple
                div(style="color: #333; font-size: 13px; font-weight: 700; margin-bottom: 4px;") {{ metodo.metodonombre }}
                div(style="border-top: 1px solid #e0e0e0; padding-top: 4px; margin-top: 4px;")
                  div(style="display: flex; justify-content: space-between; margin-bottom: 2px;")
                    span(style="color: #999; font-size: 10px;") Cant:
                    strong(style="color: #333; font-size: 11px;") {{ metodo.cantidad }}
                  div(style="display: flex; justify-content: space-between;")
                    span(style="color: #999; font-size: 10px;") Total:
                    strong(style="color: #2196F3; font-size: 12px;") ${{ metodo.total.toFixed(2) }}
        
        // Card para el total general
        v-flex(xs6 sm4 md3 lg2 style="padding: 3px;")
          v-card(elevation="3" style="height: 100%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);")
            v-card-text(style="padding: 6px;")
              div(style="text-align: center; color: white;")
                v-icon(small color="white" style="margin-bottom: 2px;") mdi-calculator
                div(style="font-size: 13px; font-weight: 700; margin-bottom: 4px;") TOTAL GENERAL
                div(style="border-top: 1px solid rgba(255,255,255,0.3); padding-top: 4px; margin-top: 4px;")
                  div(style="display: flex; justify-content: space-between; margin-bottom: 2px;")
                    span(style="font-size: 10px;") Registros:
                    strong(style="font-size: 11px;") {{ totalRegistros }}
                  div(style="display: flex; justify-content: space-between;")
                    span(style="font-size: 10px;") Total:
                    strong(style="font-size: 13px;") ${{ totalGeneral.toFixed(2) }}
                    
    v-dialog(v-model='dialog7', persistent max-width='1000px')
          v-container(style='background-color:white !important;max-width: 1000px;')
            v-card-title.justify-center
              span.headline Cobro
            div(style="margin-top: 10px;" v-if='itemMov')
              v-flex(xs12, sm12, md12)
                v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
                  v-flex(xs4 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Nro:
                      span {{itemMov.nro}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha:
                      span {{transform2(itemMov.fechaC)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha de pago:
                      span {{transform(itemMov.fechaP)}}
                  v-flex(xs5 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Vendedor:
                      span {{itemMov.vendedor}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Cliente:
                      span(v-if='itemMov.cliente && itemMov.cliente.cli_des') {{itemMov.cliente.cli_des}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Rif Titular:
                      span(v-if='itemMov.titular') {{itemMov.titular}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Método:
                      span {{itemMov.metodo}}
                  v-flex(xs3 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Monto:
                      span ${{formatMiles(itemMov.monto)}}
                    div(v-if='itemMov.montoBs')
                      span(style='font-weight:500;padding-right:3px;') Monto Bs:
                      span Bs.{{formatMiles(itemMov.montoBs)}}
                    div(v-if='itemMov.moneda')
                      span(style='font-weight:500;padding-right:3px;') Moneda:
                      span {{itemMov.moneda}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Referencia:
                      span(v-if='itemMov.referencia') {{itemMov.referencia}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Cobro:
                      span(v-if='itemMov.nroCobro') {{itemMov.nroCobro}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Estatus:
                      span {{itemMov.estatus}}
            v-card-title.justify-center
              span.headline Posibles movimientos asociados
            div(style="margin-top: 10px;")
              v-flex(xs12, sm12, md12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-flex(xs12)
                    v-form(enctype="multipart/form-data")

                      v-data-table.elevation-1(v-model="selectMov" :single-select="true" item-key="_id" :headers='headersMov' :pagination.sync="paginationMov" :items="resultadosMov" style="margin-top: 5px;")
                        template(slot='items', slot-scope='props')
                          td
                            v-checkbox(
                              :value='props.item'
                              style='margin: 0px;padding: 0px;'
                              hide-details=''
                              v-model="selectMov"
                            )
                          td {{ transform(props.item.fecha)}}
                          td {{ props.item.descripcion }}
                          td {{ props.item.banco }}
                          td {{ formatMiles(props.item.monto) }}
                          td {{ props.item.referencia }}
                          td {{ props.item.estatus }}

                      div
                        v-flex(v-if="loading === true", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-progress-circular(indeterminate='', color='primary')
                        v-flex(v-if="loading === false", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                              v-btn(v-if='selectMov && selectMov.length > 0' style="background:green;border-radius:10px;", @click.native='editItemAproMov') Guardar
                              v-btn(style="background:black;border-radius:10px;", @click.native='closeMov') Salir
    v-dialog(v-model='dialog3', persistent max-width='70%')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(style="display: flex;justify-content: space-between;align-items: center;")
              div(style='display: flex;justify-content: space-between;align-items: center;margin-bottom:20px')
                img(src='../assets/logob.jpg', style='height: auto;width: 100px;object-fit:contain;')
              div(align='center')
                h4(style='font-weight: 700 !important;') RECIBO DE COBRO
              div(style='display: flex;justify-content: space-between;align-items: center;margin-bottom:20px')
                img(src='../assets/logo2.png', style='height: auto;width: 55px;object-fit:contain;')
            table(style='width: 100%;margin-top: 10px;border-collapse: collapse;font-weight: bold;line-height: normal;')
              tr
                td(align='left' style='padding: 0px;border: none;')
                  span DISTRIBUIDOR: {{form.vendedor}}
                td(align='right' style='padding: 0px;border: none;')
                  span NRO COBRO: {{form.nro}}
              tr
                td(align='left' style='padding: 0px;border: none;')
                  span CLIENTE: {{form.cliente.cli_des}}
                td(align='right' style='padding: 0px;border: none;')
                  span FECHA REG: {{form.fechaC}}
              tr
                td(align='left' style='padding: 0px;border: none;')
                  span(v-if="form.cliente.telefonos") TELF.: {{form.cliente.telefonos}}
                  span(v-else) TELF.: N/A
                td(align='right' style='padding: 0px;border: none;')
                  span.monto-grande(v-if="form.monto") MONTO PAGADO: {{formatMiles(form.monto)}}
                  span(v-else) MONTO PAGADO: N/A
              tr
                td(align='left' style='padding: 0px;border: none;')
                  span(v-if="form.cliente.email") EMAIL: {{form.cliente.email}}
                  span(v-else) EMAIL: N/A
                td(style='padding: 0px;border: none;')  
            table(border="0" align="center" style='width: 100%;margin-top: 20px;')
              tr
                td(align='center').withTd2
                  span FORMA DE PAGO
                td(align='center').withTd2
                  span {{form.metodonombre}}
              tr
                td(align='center').withTd2
                  span TITULAR
                td(align='center').withTd2
                  span(v-if="form.titular && form.titular !== 'null'") {{form.titular}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span FACTURAS
                td(align='center').withTd2
                  span(v-if="form.fact && form.fact.length > 0") {{form.fact}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span MONTO EN $
                td(align='center').withTd2
                  span(v-if="form.monto") {{formatMiles(form.monto)}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span MONTO EN BS
                td(align='center').withTd2
                  span(v-if="form.montoBs") {{formatMiles(form.montoBs)}}
                  span(v-else-if="form.monto && form.tasa") {{formatMiles(form.monto * form.tasa)}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span TASA DE CAMBIO
                td(align='center').withTd2
                  span(v-if="form.tasa") {{form.tasa.toFixed(2)}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span FECHA DE LA TASA
                td(align='center').withTd2
                  span(v-if="form.fechaTasa") {{transform(form.fechaTasa)}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span DESCUENTO
                td(align='center').withTd2
                  span(v-if="form.descuento && form.descuento != 'null'") {{form.descuento}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span REFERENCIA TRANSFERENCIA
                td(align='center').withTd2
                  span(v-if="form.referencia && form.referencia != 'null'") {{form.referencia}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span DESCRIPCIÓN
                td(align='center').withTd2
                  span(v-if="form.descripcion && form.descripcion !== 'null'") {{form.descripcion}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span OBSERVACIÓN
                td(align='center').withTd2
                  span(v-if="form.tipoObs && form.tipoObs !== 'null'") {{form.tipoObs}}
                  span(v-else) N/A

          div(v-if='form.bauche || form.bauche2' style='margin-top: 30px;')
            div(style='text-align: center; margin-bottom: 15px;')
              span(style='font-weight: bold;') IMÁGENES
            div(style='display: flex; justify-content: space-between; align-items: start; gap: 20px;')
              div(v-if='form.bauche' style='flex: 1; text-align: center;')
                img(:src='ruta + form.bauche', style='max-height: 180px; width: auto; object-fit: contain;')
              div(v-if='form.bauche2' style='flex: 1; text-align: center;')
                img(:src='ruta + form.bauche2', style='max-height: 180px; width: auto; object-fit: contain;')

        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog2', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")
                            
                            v-text-field(
                            outline
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:red;border-radius:10px;", @click.native='save2()') Modificar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close2') Salir
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.metodonombre"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")

                            v-text-field(v-if='form.montoBs'
                            outline
                            readonly
                            v-model="form.montoBs"
                            prepend-inner-icon="description"
                            label="Monto Bs:")
                            
                            v-text-field(v-if='form.referencia'
                            outline
                            readonly
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche' style='width: 425px;height: auto;')

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche2')
                              a(:href='ruta + form.bauche2' target='_blank')
                                img(:src='ruta + form.bauche2' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.nroCobro'
                              readonly
                              v-model="form.nroCobro"
                              prepend-inner-icon="description"
                              label="Nro. de cobro:")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    //- v-btn(v-if='form.estatus === "Aprobado"' style="background:green;border-radius:10px;", @click.native='save("P")') Procesado
                                    v-btn(v-if='(form.estatus === "Pendiente" || form.estatus === "Conciliado") && !form.valija' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 8px;')
        // ===== BARRA DE FILTROS MODERNA =====
        v-card(elevation='4' style='border-radius: 14px; background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); padding: 16px 20px; margin-bottom: 8px;')
          v-layout(row wrap align-start)
            // Buscador
            v-flex(xs12 sm3 style='padding: 4px 8px;')
              div(style='color: rgba(255,255,255,0.65); font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;')
                v-icon(style='font-size:12px; color: rgba(255,255,255,0.65);') mdi-magnify
                span Buscar
              v-text-field(
                v-model='search'
                placeholder='Nombre, referencia, nro...'
                solo
                hide-details
                dense
                style='border-radius: 8px; font-size: 13px;'
              )
            // Estatus
            v-flex(xs6 sm2 style='padding: 4px 8px;')
              div(style='color: rgba(255,255,255,0.65); font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;')
                v-icon(style='font-size:12px; color: #69f0ae;') mdi-check-circle-outline
                span(style='color: #69f0ae;') Estatus
              v-select(
                :items='filtros'
                v-model='seleccionFiltro'
                solo
                hide-details
                dense
                @change='cambiarFiltro()'
                style='border-radius: 8px; font-size: 13px;'
              )
            // Método de pago
            v-flex(xs6 sm2 style='padding: 4px 8px;')
              div(style='color: rgba(255,255,255,0.65); font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;')
                v-icon(style='font-size:12px; color: #64b5f6;') mdi-credit-card-outline
                span(style='color: #64b5f6;') Método de pago
              v-select(
                :items='metodosDisponibles'
                v-model='seleccionMetodo'
                solo
                hide-details
                dense
                @change='cambiarFiltro()'
                style='border-radius: 8px; font-size: 13px;'
              )
            // Vendedor
            v-flex(xs12 sm2 style='padding: 4px 8px;')
              div(style='color: rgba(255,255,255,0.65); font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;')
                v-icon(style='font-size:12px; color: #ce93d8;') mdi-account-outline
                span(style='color: #ce93d8;') Vendedor
              v-select(
                :items='vendedoresDisponibles'
                v-model='seleccionVendedor'
                solo
                hide-details
                dense
                @change='cambiarFiltro()'
                style='border-radius: 8px; font-size: 13px;'
              )
            // Rango de fechas + acciones
            v-flex(xs12 sm3 style='padding: 4px 8px;')
              div(style='color: rgba(255,255,255,0.65); font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px;')
                v-icon(style='font-size:12px; color: #ffcc80;') mdi-calendar-range
                span(style='color: #ffcc80;') Rango de fechas
              v-layout(row align-center style='gap: 6px;')
                v-flex
                  v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y max-width='450px' min-width='450px')
                    template(v-slot:activator='{ on, attrs }')
                      v-text-field(
                        v-model='dateRangeText'
                        placeholder='Seleccionar fechas...'
                        solo
                        hide-details
                        dense
                        readonly
                        v-bind='attrs'
                        v-on='on'
                        style='border-radius: 8px; font-size: 13px;'
                      )
                    v-date-picker(multiple v-model='dates' no-title dark)
                      v-spacer
                      v-btn(text color='primary' @click='$refs.menu1.save(dates)') OK
                v-btn(
                  @click='buscarFecha'
                  style='background: linear-gradient(135deg,#e53935,#b71c1c); border-radius: 8px; color: white; font-weight: 700; height: 40px; flex-shrink: 0; padding: 0 14px;'
                ).elevation-4
                  v-icon(left color='white' small) mdi-magnify
                  | Buscar
                vue-excel-xlsx(
                  v-if='resultados && resultados.length > 0'
                  :data='dataExcel'
                  :columns='columnsExcel'
                  :filename="'Emanuel-Cobros'"
                  :sheetname="'sheetname'"
                  style='display:flex;align-items:center;'
                )
                  img(src='../assets/iconos/excel.png' style='height: 36px; width: auto; cursor: pointer;')
                v-btn(
                  v-if='cobrosSeleccionados.length > 0'
                  @click='imprimirMasivo'
                  style='background: linear-gradient(135deg,#e65100,#bf360c); border-radius: 8px; color: white; font-weight: 700; height: 40px; flex-shrink: 0; padding: 0 14px;'
                ).elevation-4
                  v-icon(left color='white' small) mdi-printer-check
                  | PDF ({{ cobrosSeleccionados.length }})
        // ===== CHIPS DE FILTROS ACTIVOS =====
        v-layout(row wrap style='margin-bottom: 4px; gap: 4px; padding: 0 2px;' v-if='seleccionFiltro !== "todos" || seleccionMetodo !== "todos" || seleccionVendedor !== "todos"')
          v-chip(small close color='teal darken-1' text-color='white' v-if='seleccionFiltro !== "todos"' @input='seleccionFiltro = "todos"; cambiarFiltro()')
            v-icon(left small) mdi-check-circle-outline
            | Estatus: {{seleccionFiltro}}
          v-chip(small close color='blue darken-1' text-color='white' v-if='seleccionMetodo !== "todos"' @input='seleccionMetodo = "todos"; cambiarFiltro()')
            v-icon(left small) mdi-credit-card-outline
            | Método: {{seleccionMetodo}}
          v-chip(small close color='purple darken-1' text-color='white' v-if='seleccionVendedor !== "todos"' @input='seleccionVendedor = "todos"; cambiarFiltro()')
            v-icon(left small) mdi-account-outline
            | Vendedor: {{seleccionVendedor}}
        v-card(color='' style='border-radius: 0px 0px 20px 20px;background-color:black;')
          v-card-title(style='padding: 7px;margin-top: 0px;').justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" v-model="cobrosSeleccionados" select-all item-key="_id" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td
              v-checkbox(v-model="props.selected" primary hide-details style="margin:0;padding:0;")
            td {{ props.item.nro }}
            td {{ transform(props.item.fechaC)}}
            td {{ transform(props.item.fechaP)}}
            td {{ props.item.vendedor }}
            td(v-if='props.item.cliente && props.item.cliente.cli_des') {{ props.item.cliente.cli_des }}
            td(v-else) N/A
            td {{ props.item.metodonombre }}
            td {{ props.item.monto}}
            td(v-if='props.item.tasa') {{ props.item.tasa.toFixed(2) }}
            td(v-else) N/A
            td(v-if='props.item.referencia') {{ props.item.referencia}}
            td(v-else) N/A
            td(v-if='props.item.nroCobro') {{ props.item.nroCobro}}
            td(v-else) N/A
            td(style='font-weight: bold;' :style="{ color: props.item.estatus == 'Aprobado' ? 'green' : props.item.estatus == 'Rechazado' ? 'red' : 'black'}") {{ props.item.estatus}}
            td.justify-start.layout.px-0
              v-tooltip(v-if='mod' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') edit
                | Editar.
              v-tooltip(v-if='mod && props.item.estatus == "Pendiente"' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem2(props.item)' v-on="on" color='teal') add_box
                | Modificar referencia.
              v-tooltip(bottom v-if='mod && props.item.estatus === "Pendiente" && props.item.metodonombre !== "Efectivo" && !props.item.coincide')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="blue") description
                | Conciliar.
              v-tooltip(bottom v-if='mod && props.item.estatus === "Pendiente" && props.item.metodonombre !== "Efectivo" && props.item.coincide')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="black") description
                | Conciliar.
              v-tooltip(bottom v-if='mod && props.item.estatus === "Conciliado"')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='revertirConciliacion(props.item)' v-on="on" color="orange") link_off
                | Revertir conciliación.
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem3(props.item)' v-on="on" color='teal') description
                | Exportar pdf.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import printJS from 'print-js'
export default {
  name: "Cobros",
  data: vm => ({
    ruta: serverImg,
    cobrosSeleccionados: [],
    resumenPorMetodo: [],
    totalGeneral: 0,
    totalRegistros: 0,
    itemMov: null,
    typeMov: null,
    selectMov: [],
    resultadosMov: [],
    resultadosMovAll: [],
    paginationMov: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    headersMov: [
      { text: "Check", value: "check" },
      { text: "Fecha", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" }
    ],
    dates: [],
    loading: false,
    dialog7: false,
    dialog3: false,
    dialog4: false,
    dialog2: false,
    seleccionFiltro: 'todos',
    seleccionMetodo: 'todos',
    seleccionVendedor: 'todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Conciliados",
        value: "Conciliado"
      },
      {
        text: "Aprobados",
        value: "Aprobado"
      },
      {
        text: "Rechazados",
        value: "Rechazado"
      },
      {
        text: "Procesados",
        value: "Procesado"
      },
    ],
    itemsF: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Nro",
        field: "nro",
      },
      {
        label: "Fecha",
        field: "fechaC",
      },
      {
        label: "Fecha de pago",
        field: "fechaP",
      },
      {
        label: "Vendedor",
        field: "vendedor",
      },
      {
        label: "Cliente",
        field: "cliente",
      },
      {
        label: "Método",
        field: "metodo",
      },
      {
        label: "Titular",
        field: "titular",
      },
      {
        label: "Monto",
        field: "monto",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Nro. Cobro",
        field: "nroCobro",
      },
      {
        label: "Facturas",
        field: "facturas",
      },
      {
        label: "Descripción",
        field: "descripcion",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
      {
        label: "Motivo de Rechazo",
        field: "observacion",
      },
    ],
    pagination: {
      sortBy: 'fechaC', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      nro: "",
      nroCobro: "",
      titular: "",
      vendedor: "",
      nroValija: "",
      valija: false,
      cliente: {},
      facturas: [],
      monto: null,
      montoBs: null,
      tasa: null,
      descuento: "",
      fechaTasa: "",
      tipoObs: "",
      descripcion: "",
      bauche: "",
      bauche2: "",
      metodo: "",
      referencia: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: "",
      metodonombre: "",
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Nro", value: "nro" },
      { text: "Fecha", value: "fechaC" },
      { text: "Fecha de pago", value: "fechaP" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "cliente.cli_des" },
      { text: "Método", value: "metodonombre" },
      { text: "Monto", value: "monto" },
      { text: "Tasa", value: "tasa" },
      { text: "Referencia", value: "referencia" },
      { text: "Nro. Cobro", value: "nroCobro" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción", value: "action", sortable: false }
    ],
    defaultForm: {
      nro: "",
      nroCobro: "",
      titular: "",
      vendedor: "",
      nroValija: "",
      valija: false,
      cliente: {},
      facturas: [],
      monto: null,
      montoBs: null,
      tasa: null,
      descuento: "",
      fechaTasa: "",
      tipoObs: "",
      descripcion: "",
      bauche: "",
      bauche2: "",
      metodo: "",
      referencia: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: "",
      metodonombre: "",
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
    metodosDisponibles () {
      const opciones = [{ text: 'Todos', value: 'todos' }]
      const vistos = new Set()
      for (const el of this.resultadosres) {
        if (el.metodonombre && !vistos.has(el.metodonombre)) {
          vistos.add(el.metodonombre)
          opciones.push({ text: el.metodonombre, value: el.metodonombre })
        }
      }
      return opciones
    },
    vendedoresDisponibles () {
      const opciones = [{ text: 'Todos', value: 'todos' }]
      const vistos = new Set()
      for (const el of this.resultadosres) {
        if (el.vendedor && !vistos.has(el.vendedor)) {
          vistos.add(el.vendedor)
          opciones.push({ text: el.vendedor, value: el.vendedor })
        }
      }
      return opciones.sort((a, b) => a.text.localeCompare(b.text, 'es'))
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    formatMiles(val) {
      if (val === null || val === undefined || val === '') return 'N/A';
      const num = parseFloat(val);
      if (isNaN(num)) return val;
      return num.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    editItem3(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      if (this.form.fechaC) this.form.fechaC = this.$moment(this.form.fechaC).format('DD-MM-YYYY')
      this.form.fact = ""
      if (item.facturas && item.facturas.length > 0) {
        for (let i = 0; i < item.facturas.length; i++) {
          let el = item.facturas[i];
          if (i == (item.facturas.length - 1)) {
            this.form.fact += el.nro_doc.trim()
          } else this.form.fact += el.nro_doc.trim()+", "
        }
      }
      this.form._id = item._id;
      this.dialog3 = true;
    },
    imprimirPdf () {
      const content = document.getElementById('printJS-form').innerHTML
      const ruta = this.ruta
      const bauche1 = this.form.bauche
      const bauche2 = this.form.bauche2

      // Construir sección de imágenes explícitamente desde los datos del form
      let imgsHtml = ''
      if (bauche1 || bauche2) {
        imgsHtml = `
          <div style="margin-top:30px;page-break-inside:avoid;">
            <div style="text-align:center;font-weight:bold;margin-bottom:15px;font-size:12px;border-bottom:1px solid #ccc;padding-bottom:5px;">IMÁGENES</div>
            <div style="display:flex;justify-content:space-around;align-items:flex-start;gap:20px;margin-top:10px;">
              ${bauche1 ? `<div style="flex:1;text-align:center;"><img src="${ruta + bauche1}" style="max-width:100%;max-height:320px;object-fit:contain;display:block;margin:auto;" /></div>` : ''}
              ${bauche2 ? `<div style="flex:1;text-align:center;"><img src="${ruta + bauche2}" style="max-width:100%;max-height:320px;object-fit:contain;display:block;margin:auto;" /></div>` : ''}
            </div>
          </div>`
      }

      const win = window.open('', '_blank', 'width=850,height=1100')
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8"/>
          <title>Cobro-${this.form.nroCobro || this.form.nro || ''}</title>
          <style>
            @page { size: A4; margin: 10mm; }
            body { font-family: Arial, sans-serif; font-size: 10px; line-height: 1.3; margin: 0; padding: 10mm; }
            h4 { font-size: 13px; margin: 10px 0; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
            td { padding: 3px; font-size: 10px; }
            span { font-size: 10px; }
            .monto-grande { font-size: 14px; font-weight: bold; }
            .withTd2 { border: 2px solid; padding: 4px; font-weight: bold; text-align: center; }
            @media print { body { margin: 0; padding: 0; } }
          </style>
        </head>
        <body>
          ${content}
          ${imgsHtml}
        </body>
        </html>
      `)
      win.document.close()

      // Ejecutar el print desde el window padre (evita bloqueo de scripts inline en Chrome)
      const images = Array.from(win.document.getElementsByTagName('img'))
      const total = images.length
      if (total === 0) {
        setTimeout(() => { win.focus(); win.print() }, 500)
        return
      }
      let loaded = 0
      const checkDone = () => {
        loaded++
        if (loaded >= total) {
          win.focus()
          win.print()
        }
      }
      images.forEach(img => {
        if (img.complete) {
          checkDone()
        } else {
          img.onload = checkDone
          img.onerror = checkDone
        }
      })
    },
    imprimirMasivo() {
      const ruta = this.ruta
      const fmt = (date) => date ? this.$moment(date).utc().format('DD/MM/YYYY') : 'N/A'
      const fmtMonto = (v) => (v != null && !isNaN(v)) ? parseFloat(v).toFixed(2) : 'N/A'

      const recibos = this.cobrosSeleccionados.map((item, idx) => {
        const facturas = (item.facturas || []).map(f => f.nro_doc ? f.nro_doc.trim() : '').filter(Boolean).join(', ') || 'N/A'
        const montoBs = item.montoBs
          ? parseFloat(item.montoBs).toFixed(2)
          : (item.monto && item.tasa ? (item.monto * item.tasa).toFixed(2) : 'N/A')
        const pageBreak = idx < this.cobrosSeleccionados.length - 1 ? 'page-break-after:always;' : ''
        const imgs = (item.bauche || item.bauche2) ? `
          <div style="margin-top:20px;">
            <div style="text-align:center;font-weight:bold;margin-bottom:10px;font-size:11px;border-bottom:1px solid #ccc;padding-bottom:4px;">IMÁGENES</div>
            <div style="display:flex;justify-content:space-around;align-items:flex-start;gap:16px;">
              ${item.bauche ? `<div style="flex:1;text-align:center;"><img src="${ruta + item.bauche}" style="max-width:100%;max-height:260px;object-fit:contain;" /></div>` : ''}
              ${item.bauche2 ? `<div style="flex:1;text-align:center;"><img src="${ruta + item.bauche2}" style="max-width:100%;max-height:260px;object-fit:contain;" /></div>` : ''}
            </div>
          </div>` : ''
        return `
          <div style="${pageBreak}padding:10mm;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">
              <div><img src="/img/logob.jpg" style="height:auto;width:90px;object-fit:contain;" onerror="this.style.display='none'" /></div>
              <div style="text-align:center;"><h4 style="font-size:14px;font-weight:700;margin:0;">RECIBO DE COBRO</h4></div>
              <div><img src="/img/logo2.png" style="height:auto;width:50px;object-fit:contain;" onerror="this.style.display='none'" /></div>
            </div>
            <table style="width:100%;margin-bottom:10px;border-collapse:collapse;font-size:10px;font-weight:bold;">
              <tr>
                <td style="padding:2px;border:none;">DISTRIBUIDOR: ${item.vendedor || 'N/A'}</td>
                <td style="padding:2px;border:none;text-align:right;">NRO COBRO: ${item.nro || ''}</td>
              </tr>
              <tr>
                <td style="padding:2px;border:none;">CLIENTE: ${item.cliente && item.cliente.cli_des ? item.cliente.cli_des : 'N/A'}</td>
                <td style="padding:2px;border:none;text-align:right;">FECHA REG: ${fmt(item.fechaC)}</td>
              </tr>
              <tr>
                <td style="padding:2px;border:none;">TELF.: ${item.cliente && item.cliente.telefonos ? item.cliente.telefonos : 'N/A'}</td>
                <td style="padding:2px;border:none;text-align:right;font-size:12px;">MONTO PAGADO: ${fmtMonto(item.monto)}</td>
              </tr>
              <tr>
                <td style="padding:2px;border:none;">EMAIL: ${item.cliente && item.cliente.email ? item.cliente.email : 'N/A'}</td>
                <td style="padding:2px;border:none;"></td>
              </tr>
            </table>
            <table border="0" style="width:100%;margin-top:14px;border-collapse:collapse;font-size:10px;">
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">FORMA DE PAGO</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.metodonombre || 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">TITULAR</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.titular && item.titular !== 'null' ? item.titular : 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">FACTURAS</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${facturas}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">MONTO EN $</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${fmtMonto(item.monto)}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">MONTO EN BS</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${montoBs}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">TASA DE CAMBIO</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.tasa ? parseFloat(item.tasa).toFixed(2) : 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">FECHA DE LA TASA</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${fmt(item.fechaTasa)}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">DESCUENTO</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.descuento && item.descuento !== 'null' ? item.descuento : 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">REFERENCIA TRANSFERENCIA</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.referencia && item.referencia !== 'null' ? item.referencia : 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">DESCRIPCIÓN</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.descripcion && item.descripcion !== 'null' ? item.descripcion : 'N/A'}</td></tr>
              <tr><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">OBSERVACIÓN</td><td style="border:2px solid;padding:4px;font-weight:bold;text-align:center;">${item.tipoObs && item.tipoObs !== 'null' ? item.tipoObs : 'N/A'}</td></tr>
            </table>
            ${imgs}
          </div>`
      }).join('')

      const win = window.open('', '_blank', 'width=900,height=1100')
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8"/>
          <title>Cobros (${this.cobrosSeleccionados.length})</title>
          <style>
            @page { size: A4; margin: 0; }
            body { font-family: Arial, sans-serif; font-size: 10px; margin: 0; padding: 0; }
            h4 { font-size: 13px; margin: 8px 0; }
            table { width: 100%; border-collapse: collapse; }
            @media print { body { margin: 0; } }
          </style>
        </head>
        <body>${recibos}</body>
        </html>`)
      win.document.close()
      const images = Array.from(win.document.getElementsByTagName('img'))
      const total = images.length
      if (total === 0) { setTimeout(() => { win.focus(); win.print() }, 400); return }
      let loaded = 0
      const check = () => { loaded++; if (loaded >= total) { win.focus(); win.print() } }
      images.forEach(img => { if (img.complete) check(); else { img.onload = check; img.onerror = check } })
    },
    close3() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog3 = false;
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    cambiarFiltro() {
      const estatus = this.seleccionFiltro
      const metodo = this.seleccionMetodo
      this.resultados = []
      this.dataExcel = []
      let res = []
      for (let i = 0; i < this.resultadosres.length; i++) {
        const el = this.resultadosres[i];
        const matchEstatus = estatus === 'todos' || el.estatus === estatus
        const matchMetodo = metodo === 'todos' || el.metodonombre === metodo
        const matchVendedor = this.seleccionVendedor === 'todos' || el.vendedor === this.seleccionVendedor
        if (!matchEstatus || !matchMetodo || !matchVendedor) continue
        let fcct = ""
        for (let j = 0; j < el.facturas.length; j++) {
          const el2 = el.facturas[j];
          if (j == (el.facturas.length-1)) {
            fcct += el2.nro_doc.trim() + "."
          } else fcct += el2.nro_doc.trim() + ", "
        }
        res.push(el)
        this.dataExcel.push({
          nro: el.nro,
          fechaC: this.$moment(el.fechaC).format('DD-MM-YYYY H:mm A'),
          fechaP: this.$moment(el.fechaP).format('DD-MM-YYYY H:mm A'),
          vendedor: el.vendedor,
          cliente: el.cliente.cli_des,
          metodo: el.metodonombre || el.metodo,
          titular: el.titular || 'N/A',
          monto: el.monto,
          referencia: (el.referencia) ? el.referencia : "N/A",
          nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
          facturas: fcct,
          descripcion: el.descripcion,
          estatus: el.estatus,
          observacion: (el.observacion) ? el.observacion : ""
        })
      }
      this.$nextTick(() => {
        this.resultados = res
      })
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminemanuel.permisos.length; i++) {
        if (this.$store.state.adminemanuel.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.adminemanuel.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    closeMov() {
      this.itemMov = null;
      this.typeMov = null;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = false;
    },
    buscarMovAso(item, type) {
      this.itemMov = item;
      this.typeMov = type;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = true;
      this.dialog4 = true;
      const montoConcilar = item.montoBs ? item.montoBs : item.monto
      const bancoNombre = item.metodonombre || item.metodo
      console.log('[CONCILIAR] fecha:', item.fechaP, '| banco:', bancoNombre, '| monto:', montoConcilar)
      Api.get(`movimientos/coincidencias?fecha=${item.fechaP}&banco=${encodeURIComponent(bancoNombre)}&monto=${montoConcilar}&ref=${item.referencia}`).then(res => {
        console.log('[CONCILIAR] resultados:', res.data)
        this.resultadosMov = res.data;
        this.dialog4 = false;
      }).catch(err=>{
        console.log(err)
        this.$swal.fire(
          "¡Atención!",
          err,
          "error"
        );
        this.dialog4 = false;
      });
    },
    editItemAproMov() {
      if (this.selectMov && this.selectMov.length > 0) {
        Object.keys(this.form).map(key => {
          if (this.itemMov[key]) this.form[key] = this.itemMov[key];
        });
        this.itemsF = []
        this.form.facturas = []
        for (let i = 0; i < this.itemMov.facturas.length; i++) {
          const el = this.itemMov.facturas[i];
          this.itemsF.push({
            value: el.nro_doc,
            text: el.nro_doc
          })
          this.form.facturas.push(el.nro_doc)
        }
        this.form._id = this.itemMov._id;
        this.save(this.typeMov, this.selectMov)
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debe seleccionar un movimiento para continuar",
          "error"
        );
      }
    },
    buscarFecha() {
      this.dialog4 = true
      this.dialog7 = false
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.dialog4 = false
          this.resultados = [];
          this.resultadosres = [];
          this.dataExcel = []
          this.resumenPorMetodo = res.data.resumenPorMetodo || [];
          this.totalGeneral = res.data.totalGeneral || 0;
          this.totalRegistros = res.data.totalRegistros || 0;

          if (res.data.cobros && res.data.cobros.length > 0) {
            for (let i = 0; i < res.data.cobros.length; i++) {
              let el = res.data.cobros[i];
              el.coincide = false;
              if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
              let fact = []
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (typeof el2 === "string") {
                  fact = JSON.parse(el2)
                } else fact.push(el2)
              }
              el.facturas = fact
              let fcct = ""
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (i == (el.facturas.length-1)) {
                  fcct += el2.nro_doc.trim() + "."
                } else fcct += el2.nro_doc.trim() + ", "
              }
              this.resultados.push(el)
              this.resultadosres.push(el)
              this.dataExcel.push({
                nro: el.nro,
                fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
                fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
                vendedor: el.vendedor,
                cliente: el.cliente.cli_des,
                metodo: el.metodonombre || el.metodo,
                titular: el.titular || 'N/A',
                monto: el.monto,
                referencia: (el.referencia) ? el.referencia : "N/A",
                nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
                facturas: fcct,
                descripcion: el.descripcion,
                estatus: el.estatus,
                observacion: (el.observacion) ? el.observacion : ""
              })
            }
          }
          this.buscarTodosMov()
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    revertirConciliacion(item) {
      this.$swal.fire({
        title: '¿Revertir conciliación?',
        text: `El cobro #${item.nro} volverá a estado Pendiente y el movimiento bancario quedará disponible.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, revertir',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        confirmButtonColor: '#e65100',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true
          Api.put(`cobros/revertir/${item._id}`)
            .then(() => {
              this.loading = false
              this.$swal.fire('Revertido', 'La conciliación fue revertida exitosamente.', 'success')
              this.buscarFecha()
            })
            .catch(err => {
              console.log(err)
              this.loading = false
              this.$swal.fire('Error', 'No se pudo revertir la conciliación.', 'error')
            })
        }
      })
    },
    buscarTodosMov() {
      Api.get(`movimientos/pendientes`).then(res => {
        this.resultadosMovAll = res.data;
        this.resultadosres.forEach(el => {
          const montoEl = el.montoBs ? parseFloat(el.montoBs) : parseFloat(el.monto)
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodonombre &&
              parseFloat(mov.monto) === montoEl &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
        this.resultados.forEach(el => {
          const montoEl = el.montoBs ? parseFloat(el.montoBs) : parseFloat(el.monto)
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodonombre &&
              parseFloat(mov.monto) === montoEl &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
      })
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = []
        this.resultadosres = []
        this.resumenPorMetodo = res.data.resumenPorMetodo || [];
        this.totalGeneral = res.data.totalGeneral || 0;
        this.totalRegistros = res.data.totalRegistros || 0;
        if (res.data.cobros && res.data.cobros.length > 0) {
          for (let i = 0; i < res.data.cobros.length; i++) {
            let el = res.data.cobros[i];
            el.coincide = false;
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (typeof el2 === "string") {
                fact = JSON.parse(el2)
              } else fact.push(el2)
            }
            el.facturas = fact
            let fcct = ""
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (i == (el.facturas.length-1)) {
                fcct += el2.nro_doc.trim() + "."
              } else fcct += el2.nro_doc.trim() + ", "
            }
            // console.log('llega aqui')
            // console.log(el)
            this.resultados.push(el)
            this.resultadosres.push(el)
            this.dataExcel.push({
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: el.metodonombre,
              titular: el.titular || 'N/A',
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus,
              observacion: (el.observacion) ? el.observacion : ""
            })
          }
        }
        this.dialog4 = false;
        this.buscarTodosMov()
      });
    },
    close2() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog2 = false;
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      console.log(item)
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    editItem2(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog2 = true;
    },
    save2() {
      let info = {
        _id: this.form._id,
        monto: this.form.monto,
        referencia: this.form.referencia
      }
      this.loading = true;
      Api.put("cobros", info)
        .then(() => {
          this.form = Object.assign({}, this.defaultForm);
          this.dialog2 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
          this.buscarFecha();
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    transform2(date) {
      return this.$moment(date).format("DD/MM/YYYY H:mm A")
    },
    save(item, mov = null) {
      let info
      info = {
        _id: this.form._id,
        referencia: this.form.referencia,
        mov: mov && mov.length > 0 ? mov[0] : null,
        estatus: (item === "A") ? "Aprobado" : "Rechazado"
      }
      if (item === "C") {
        info = {
          _id: this.form._id,
          referencia: mov && mov.length > 0 ? mov[0].referencia : this.form.referencia,
          referenciaOld: mov && mov.length > 0 ? this.form.referencia : null,
          mov: mov && mov.length > 0 ? mov[0] : null,
          estatus: "Aprobado"
        }
      }
      if (info.estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'select',
          inputOptions: {
            'Error en banco reportado': 'Error en banco reportado',
            'Error # de transferencia': 'Error # de transferencia',
            'No reportó # de transferencia': 'No reportó # de transferencia',
            'Pago duplicado': 'Pago duplicado',
            'Error en monto reportado': 'Error en monto reportado',
            'Sin comprobante de pago adjunto': 'Sin comprobante de pago adjunto',
            'NO APARECE EL PAGO EN EL BANCO': 'NO APARECE EL PAGO EN EL BANCO'
          },
          inputPlaceholder: 'Seleccione un motivo',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          inputValidator: (value) => {
            if (!value) return 'Debe seleccionar un motivo de rechazo.'
          }
        }).then((result) => {
          if (result.isDismissed) {
            console.log("paso cancel")
          } else if (result.value) {
            info.observacion = result.value
            this.loading = true;
            Api.put("cobros", info)
              .then(() => {
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
                this.buscarFecha();
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          }
        })
      } else {
        this.loading = true;
        Api.put("cobros", info)
          .then(() => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
            this.buscarFecha();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    }
  }
};
</script>
<style lang="scss">
.printPdf {
    @page :footer {
        display: none
    }
 
    @page :header {
        display: none
    }

    @page {
        size: A4;
        margin: 20mm;
    }

    #printJS-form {
        width: 100%;
    }

    #printJS-form table {
        width: 100%;
        border-collapse: collapse;
    }

    #printJS-form td {
        padding: 4px;
    }
}
.borderTb {
  border: 1px solid;
  text-align: center;
  width: 160px;
}
.withTd {
  width: 160px;
}
.textGrn {
  width: 100%;
  text-align: center;
}
.withTd2 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
}
.withTd3 {
  padding: 4px;
  font-weight: bold;
}
.paddText {
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
}
.divRect {
  width: 100px;
  height: 30px;
  border: 2px solid;
}
.divPrin {
  display: flex;
  align-items: center;
}
.divProd {
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divCli {
  margin-top: 20px;
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#printJS-form {
  table, th, td {
    border-collapse: collapse;
  }
}
</style>
